import React, { FC, useCallback, useMemo } from "react";
import { StyledAssetTypeFlag } from "./asset-type.styled";
import { Grid } from "@mui/material";

import {
    IconAudio,
    IconCaption,
    IconFile,
    IconImage,
    IconVideo,
    IconPhotoType,
    IconContentsVideo,
    IconAssetType,
} from "@mzc-cloudplex/icons";
import { MEDIA_TYPES } from "@constants";
import theme from "@styles/theme";

const AssetTypeFlag = ({ type, size }) => {
    const getBackgroundColor = useCallback((type) => {
        switch (type) {
            case MEDIA_TYPES.VIDEO:
                return "#405fff";
            case MEDIA_TYPES.AUDIO:
                return "#e86894";
            case MEDIA_TYPES.FILE:
                return "#3f585a";
            case MEDIA_TYPES.IMAGE:
                return "#009ea0";
            case "GENERAL":
                return theme.palette.etc.purple600;
            default:
                return "#e07f2d";
        }
    }, []);

    const styleBySize = useMemo(() => {
        switch (size) {
            case "small":
                return { width: "20px", height: "16px", iconSize: "12px" };
            case "medium":
            default:
                return { width: "24px", height: "20px", iconSize: "16px" };
        }
    }, [size]);

    return (
        <StyledAssetTypeFlag
            sx={{
                width: styleBySize.width,
                height: styleBySize.height,
                color: `#fff`,
                backgroundColor: getBackgroundColor(type),
            }}
        >
            {type === "VIDEO" && <IconContentsVideo size={styleBySize.iconSize} />}
            {type === "AUDIO" && <IconAudio size={styleBySize.iconSize} />}
            {type === "FILE" && <IconFile size={styleBySize.iconSize} />}
            {type === "IMAGE" && <IconPhotoType size={styleBySize.iconSize} />}
            {type === "CAPTION" && <IconCaption size={styleBySize.iconSize} />}
            {type === "TEXT" && <IconCaption size={styleBySize.iconSize} />}
            {type === undefined && false && <IconFile size={styleBySize.iconSize} />}
            {type === "GENERAL" && <IconAssetType size={styleBySize.iconSize} />}
        </StyledAssetTypeFlag>
    );
};

export default AssetTypeFlag;
